import React from "react";
import { ArrowDownIcon } from "@heroicons/react/24/solid";
import {
  Card,
  CardHeader,
  Typography,
  Button,
  CardBody,
  Input,
} from "@material-tailwind/react";

export default function OrganizationInfo() {
  return (
    <div className="app-main__inner !pl-20">
      <Card
        className="h-full w-full rounded-3xl shadow-xl"
        style={{ backgroundImage: `url('/assets/images/beams.jpg')` }}
      >
        <CardHeader
          floated={false}
          shadow={false}
          className=" bg-transparent rounded-none !overflow-visible"
        >
          <div className="mb-8 flex flex-col md:flex-row md:items-center md:justify-between md:gap-8">
            <div>
              <Typography variant="h5" color="blue-gray">
                Organization Information
              </Typography>
              <Typography color="gray" className="mt-1 font-normal">
                View organization details
              </Typography>
            </div>
            <div className="flex flex-row md:flex-row items-center justify-between md:items-center gap-2 md:gap-8 mt-4 md:mt-0 cursor-not-allowed">
              <Button variant="outlined" size="sm" disabled="true">
                <ArrowDownIcon strokeWidth={2} className="h-4 w-4" />
              </Button>
            </div>
          </div>
        </CardHeader>
        <CardBody className="px-3 p-0">
          <form>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4 ">
              <Input
                type="text"
                label="Legal Name"
                size="lg"
                value=""
                name="legalName"
                className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                disabled
              />
              <Input
                type="text"
                label="Domain"
                size="lg"
                name="domain"
                value=""
                className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                disabled
              />
              <Input
                type="text"
                label="Registered Address"
                size="lg"
                name="address"
                value=""
                className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                disabled
              />
            </div>
          </form>
        </CardBody>
      </Card>
    </div>
  );
}
